define('drops/dynamicText/dynamicText',[
    'jquery',
    'lq',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/richText',
    'lq/html',
    'lq/constants',
    'lq/tooltip',
    'lq/onlongpress'
], function($, lq, Drop, Style, util, richText, html, constants, Tooltip, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            trimTextWithEllipsis: false,
            useDynamicWidth: true,
            useDynamicHeight: true,
            hideWhenEmpty: false,
            title: {
                option: Tooltip.hardcoded
            }
        }
    };

    var base = Drop;
    function DynamicText(options) {
        base.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.$element
            .addClass('boxToBorderSize drop-text-container dynamic-text');

        if (!this.designData && this.isEventEnabled('onLongPress')) {
            OnLongPress.applyLongPressOnElement(this.$element, this);
        } else if (this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            this.applyEventTrigger('clicked', 'click');
            this.$element.addClass('clickable');
        }

        this.applyEventTrigger('mouseEnter', 'mouseenter');

        this.tooltip = new Tooltip(this, this.data.title, this.$element);
    };

    base.extend(DynamicText);

    DynamicText.typeName = 'DynamicText';

    DynamicText.prototype.showMockData = function (mockData) {
        this.setValue({ value: this.getMockTextToShow(mockData), type: constants.string });
    };

    DynamicText.prototype.getMockTextToShow = function (mockData) {
        return mockData;
    };

    DynamicText.prototype.updateMockData = function () {
        this.applyPosition();
    };

    DynamicText.prototype.preRender = function () {
        this.tooltip.update();

        this.piping.visibility.apply(this);
        this.formatter = this.piping.formatting.createFormatter(this.data.formatting);

        if (!this.data.hideWhenEmpty)
            this.showPlainText();
        else {
            this.$element.hide();
        }

        if (this.data.mockData)
            this.showMockData(this.data.mockData);

        this.applyPosition();
    };

    DynamicText.prototype.clearValue = function () {
        if (this.data.hideWhenEmpty)
            this.hide();
        else {
            if (this.$label)
                this.$label.text('');
            else
                this.richTextEditor.fromString('');
        }
    };

    DynamicText.prototype.setValue = function (update) {
        if (richText.isRichTextString(update.value)) {
            this.hidePlainText();
            this.showRichText();
            this.richTextEditor.fromString(update.value);
            this.$element.show();
        } else {
            this.hideRichText();
            this.showPlainText();

            var text = this.formatter.convertFromLicquidFormat(update.type, update.value);

            if (this.data.renderAsHtml) {
                if (text) {
                    var regex = new RegExp('{{{TenantUrl}}}', 'g');
                    text = text.replace(regex, lq.getTenantUrl(''));
                }

                this.$label
                    .html(text || '')
                    .css('whiteSpace', 'normal');
            } else {
                if (this.data.stripHtml && text)
                    text = html.strip(text);

                this.$label
                    .text(text || '')
                    .css('whiteSpace', 'pre-wrap');
            }

            if (this.data.trimTextWithEllipsis)
                this.tooltip.update(text);

            if (this.data.hideWhenEmpty) {
                if (text === null || text === undefined || text === '') {
                    this.$element.hide();
                } else {
                    this.$element.show();
                }
            }
        }
    };

    // backwards compatibility
    DynamicText.prototype.getValue = function () {
        if (this.$label)
            return this.$label.text();
        return null;
    };

    DynamicText.prototype.hideRichText = function () {
        if (this.richTextEditor) {
            this.richTextEditor.close();
            this.richTextEditor = null;
        }
    };

    DynamicText.prototype.hidePlainText = function () {
        if (this.$label) {
            this.$label.remove();
            this.$label = null;
        }
    };

    DynamicText.prototype.showRichText = function () {
        if (!this.richTextEditor) {
            this.richTextEditor = new richText.RichTextEditor({
                parentElement: this.$element,
                sections: this.data.sections,
                editable: false
            });

            this.renderStyles();
        }
    };

    DynamicText.prototype.renderStyles = function () {
        if (this.richTextEditor) {
            Style.renderStyles(this, null, this.richTextEditor.$element);
        } else {
            Style.renderStyles(this, null, this.$element);
        }
    };

    DynamicText.prototype.showPlainText = function () {
        var self = this;
        if (!this.$label) {

            if (self.data.trimTextWithEllipsis) {
                this.$labelWrapper = $('<div />')
                    .addClass('ellipsis')
                    .addClass('boxToBorderSize')
                    .css({
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$element);

                this.$innerLabelWrapper = $('<div />')
                    //.css('display', 'table')
                    .appendTo(this.$labelWrapper);

                this.$label = $('<p />')
                    .addClass('drop-text-content')
                    .css({
                        whiteSpace: 'pre-wrap',
                        marginRight: '10px',
                        margin: '0'
                    })
                    .appendTo(this.$innerLabelWrapper);
            } else {
                this.$overflowWrapper = $('<div />')
                    .addClass('overflow-wrapper')
                    .appendTo(this.$element);

                this.$labelWrapper = $('<div />')
                    .css({
                        display: 'table',
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$overflowWrapper);

                this.$label = $('<div />')
                    .addClass('boxToBorderSize drop-text-content')
                    .css({
                        display: 'table-cell',
                        wordWrap: this.data.wordWrap,
                        width: '100%',
                        height: '100%'
                    })
                    .appendTo(this.$labelWrapper);;

                if (this.data.showScrollbar) {
                    this.$element.css({
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    });
                }
            }

            this.renderStyles();
        }
    };

    return DynamicText;
});
